<template>
    <div class="login-page">
        <loading />
    </div>
</template>

<script>
    export default {
        created() {

            let token = this.$route.params.token;
            this.$store.state.authentication.authToken = token;
            this.$http.get(this.config.api + "/user/authenticate").then(res => {

                this.$store.state.authentication.checked = true;
                
                if (res.body.status == 'success') { 
                    this.$store.state.authentication.loggedIn = true;
                    this.$store.state.authentication.user_hash = res.body.data.user_hash;
                    this.$store.state.authentication.user_name = res.body.data.user_name;
                    this.$store.state.authentication.user_unit_name = res.body.data.user_unit_name;
                    this.$cookie.set('auth', this.$store.state.authentication.authToken, 4);
                    this.$router.push("/");
                } else {
                    this.$store.state.authentication.loggedIn = false;
                    this.$store.state.authentication.authToken = null;
                    this.$cookie.delete("auth");
                    this.$router.push("/");
                }
            })
        }
    }
</script>

<style scoped>
    .login-page {
        background-color: #FFF;
        position: absolute;
        width: 100%;
        height: 100vh;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Auth.vue